export const locale = {
    lang: 'ar',
    data: {
        TRANSFORM_EXPORT: 'تصدير بطاقة إلى نشاط آخر',
        SELECTION: 'اختيار',
        ACTIVITY: 'نشاط',
    }
};
